import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    useRecordContext,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import {
    Grid,
    LinearProgress
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const EditAddressTitle: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    if (!record) return null;
    return <span>{ "Customer Address - " + record.id }</span>
}

export const AdminAddressEdit: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return (
        <Edit title={ <EditAddressTitle /> }>
            <SimpleForm>
                <Grid container spacing={ 2 }>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <TextInput name="line_one" source="line_one" validate={[required()]} />
                        <TextInput name="line_two" source="line_two" />
                        <TextInput name="city" source="city" validate={[required()]} />
                        <TextInput name="county" source="county" />
                    </Grid>
                    <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                        <TextInput name="postcode" source="postcode" validate={[required()]} />
                        { (loading) &&
                            <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                        }
                        { (!loading) &&
                            <SelectInput
                                name="country"
                                source="country"
                                optionValue="id"
                                choices={ loadedCountries }
                                validate={[required()]}
                            />
                        }

                        { /* `link` is not a ReferenceInput prop and never did anything here. It
                             is gone with the company Show route it named, 2026-09-10. */ }
                        <ReferenceInput
                            name="company"
                            label="Company"
                            source="company"
                            reference="companies">
                            <SelectInput name="name" optionText="name" validate={[required()]} />
                        </ReferenceInput>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}